import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import * as ObjectSegFilterTypes from 'customer-data-filters-ui/converters/objectSeg/ObjectSegFilterTypes';
import { parseDynamicFilterFamilyId } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import getIn from 'transmute/getIn';
import toValueComparison from './util/toValueComparison';
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'operator' implicitly has an 'any' type.
const _toIntegrationFilter = (operator, valueComparison, integrationId) => ({
  filterType: ObjectSegFilterTypes.INTEGRATION_EVENT,
  eventTypeId: integrationId,
  filterLines: [{
    property: getIn(['field', 'name'], operator),
    operation: valueComparison
  }]
});
const toIntegrationFilter = (operator, filterFamily, options) => {
  const valueComparison = toValueComparison(operator, options);
  const integrationId = parseDynamicFilterFamilyId(DSAssetFamilies.INTEGRATION, filterFamily);
  return _toIntegrationFilter(operator, valueComparison, integrationId);
};
export default toIntegrationFilter;